import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Box,
  Button,
  CircularProgress,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import useAuthStore from "../../hooks/store/auth";
import { Layout as AuthLayout } from "../../common/Layout/auth/layout";
import { useNavigate } from "react-router-dom";

const Page = () => {
  const { resetAction, loading } = useAuthStore();
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      email: "",
      submit: null,
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Must be a valid email")
        .max(255)
        .required("Email is required"),
    }),
    onSubmit: async (values, helpers) => {
      const result = await resetAction({ email: values.email });

      if (result?.type === "auth/reset/fulfilled") {
        navigate("/");
        return;
      }

      helpers.setStatus({ success: false });
      helpers.setErrors({
        submit: result?.payload || "Unable to reset password",
      });
      helpers.setSubmitting(false);
    },
  });

  return (
    <AuthLayout>
      <Box
        sx={{
          flex: "1 1 auto",
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            maxWidth: 550,
            px: 3,
            py: "100px",
            width: "100%",
          }}
        >
          <div>
            <Stack spacing={1} sx={{ mb: 3 }}>
              <Typography variant="h4">Reset Password</Typography>
            </Stack>
            <form noValidate onSubmit={formik.handleSubmit}>
              <Stack spacing={3}>
                <TextField
                  error={!!(formik.touched.email && formik.errors.email)}
                  fullWidth
                  helperText={formik.touched.email && formik.errors.email}
                  label="Email Address"
                  name="email"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  type="email"
                  value={formik.values.email}
                />
              </Stack>
              {formik.errors.submit && (
                <Typography color="error" sx={{ mt: 3 }} variant="body2">
                  {formik.errors.submit}
                </Typography>
              )}
              <Button
                fullWidth
                size="large"
                sx={{ mt: 3 }}
                type="submit"
                variant="contained"
              >
                {loading ? (
                  <CircularProgress size={25} style={{ color: "#0b3b4b" }} />
                ) : (
                  "Reset"
                )}
              </Button>
            </form>
          </div>
        </Box>
      </Box>
    </AuthLayout>
  );
};

Page.getLayout = (page) => <AuthLayout>{page}</AuthLayout>;

export default Page;
